import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import moment from 'moment';
import { useMemo } from 'react';
import { PROFFIT_SEARCH_PRICE } from '../../../../../../../define/consts/proffit_search/proffit_search_service';
import { calcIncludingTax } from '../../../../../../../helpers/calc/tax';
import { propShape } from '../../../../../../../helpers/custom-prop-types';
import DateText from '../../../../../../Ui/Common/DateText';
const UpdateModalTable = (props) => {
    const { item, now } = props;
    const { email, expiredAt, firstName, isExpired, lastName } = item;
    const updateExpire = useMemo(() => {
        let judgeMoment;
        if (isExpired) {
            judgeMoment = now;
        }
        else {
            judgeMoment = moment(expiredAt);
        }
        // 期限切れでない場合は期間から延長
        return judgeMoment.clone().add(1, 'year');
    }, [now, expiredAt, isExpired]);
    const name = useMemo(() => `${lastName} ${firstName}`.trim() || email, [lastName, firstName, email]);
    return (_jsxs("div", Object.assign({ className: 'update_modal_table_row' }, { children: [_jsx("div", Object.assign({ className: 'update_modal_table_col update_modal_table_col_name' }, { children: _jsx("div", Object.assign({ className: 'update_modal_table_col_inner update_modal_table_col_name_inner' }, { children: name })) })), _jsx("div", Object.assign({ className: 'update_modal_table_col update_modal_table_col_expire' }, { children: _jsx("div", Object.assign({ className: 'update_modal_table_col_inner' }, { children: _jsx(DateText, { format: 'YYYY年MM月DD日', value: updateExpire }) })) })), _jsx("div", Object.assign({ className: 'update_modal_table_col update_modal_table_col_price' }, { children: _jsx("div", Object.assign({ className: 'update_modal_table_col_inner is-last' }, { children: `${calcIncludingTax(PROFFIT_SEARCH_PRICE).toLocaleString()}円` })) }))] })));
};
UpdateModalTable.propTypes = {
    item: propShape().isRequired,
    now: propShape().isRequired,
};
export default UpdateModalTable;
